<!--
Author: Lsc
Date: 2019-8-30
Desc: 对账单信息组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-statement bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="statement-content">
            <el-row class="statement-form">
                <el-col :span="12">
                    投资者名称：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].custname : "--" }}
                </el-col>
                <el-col :span="12">
                    经办人名称：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].transactornamestr : "--" }}
                </el-col>
                <!-- <el-col :span="12">
                    法人名称：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].lawname : "&#45;&#45;" }}
                </el-col>-->
                <!--<el-col :span="12">-->
                    <!--基金账号：&emsp;{{ (statementInfo && statementInfo[0]) ? statementInfo[0][0].fundacco : "&#45;&#45;" }}-->
                <!--</el-col>-->
                <el-col :span="12" v-if="$cache.getCompanyInfo()&&$cache.getCompanyInfo().companypostcode">
                    邮政编码：&emsp;&emsp;{{ $cache.getCompanyInfo()&&$cache.getCompanyInfo().companypostcode}}
                </el-col>
                <el-col :span="12" v-if="$cache.getCompanyInfo()&&$cache.getCompanyInfo().faxnumber">
                    传真：&emsp;&emsp;&emsp;&emsp;{{ $cache.getCompanyInfo()&&$cache.getCompanyInfo().faxnumber }}
                </el-col>
                <el-col :span="24" v-if="$cache.getCompanyInfo()&&$cache.getCompanyInfo().companyname">
                    地址：&emsp;&emsp;&emsp;&emsp;{{ $cache.getCompanyInfo()&&$cache.getCompanyInfo().companyname}}
                </el-col>
            </el-row>
            <el-row class="statement-filter">
                <el-col :span="24">
                    <el-button
                        type="blue"
                        class="print-btn right"
                        v-on:click.prevent="printStatement"
                        :disabled="loading"
                    >
                        {{loading?"打印中......":"打印对账单信息"}}
                    </el-button>
                    <el-button
                        type="blue"
                        class="print-btn right"
                        v-on:click.prevent="getStatement"
                    >
                        查询
                    </el-button>
                    <div class="right">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </div>
                    <span class="right date-text">
                        选择日期区间：
                    </span>
                </el-col>
            </el-row>
            <div class="table-title">
                账户余额报告：
            </div>
            <el-table
                :data="statementInfo[2]"
                border
                style="width: 100%"
            >
                <el-table-column
                    label="销售机构"
                    width="120"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ $cache.getDict('110070',scope.row.distributorcode, scope.row.distributorcode) || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="fundcode"
                    label="基金代码"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    width="200"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="期末份额（份）"
                    width="150"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.holdfund || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="期末份额净值"
                    width="180"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.nav || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="totalassert"
                    label="期末份额市值（元）"
                    width="180"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.totalassert || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="分红方式"
                    width="100"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ $cache.getDict("110001", scope.row.dividendmethod, scope.row.dividendmethod) || "-" }}
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                    <!--prop="distributorname"-->
                    <!--label="销售机构"-->
                    <!--width="180"-->
                    <!--align="center"-->
                <!--&gt;-->
                <!--</el-table-column>-->
                <el-table-column
                    prop="income"
                    label="未付收益"
                    width="100"
                    align="center"
                >
                </el-table-column>
            </el-table>
            <div class="table-title">
                基金交易明细：
            </div>
            <el-table
                :data="statementInfo[1]"
                border
                style="width: 100%"
            >
                <el-table-column
                    label="销售机构"
                    width="120"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ $cache.getDict('110070',scope.row.distributorcode, scope.row.distributorcode) || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="transactionappdate"
                    label="申请日期"
                    width="120"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    width="200"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="业务类型"
                    width="100"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ $cache.getDict("130010", scope.row.businesscode) || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="确认金额（元）"
                    width="150"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.confirmedamount || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="确认份额（份）"
                    width="150"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.confirmedvol || "-" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="nav"
                    label="基金净值"
                    width="150"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.nav }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="总费用（元）"
                    width="180"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.businesscode === "43" &&
                        ($util.isEmpty(scope.row.charge) || scope.row.charge === "0.00")  ? "-" : scope.row.charge }}
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                    <!--prop="distributorname"-->
                    <!--label="销售机构"-->
                    <!--width="100"-->
                    <!--align="center"-->
                <!--&gt;-->
                <!--</el-table-column>-->
            </el-table>
            <!-- v-if="allPage - 0 >= Number(qryArea.pagecount)" -->
            <el-row v-if="allPage - 0 !== 0" class="page-box">
                <el-pagination
                    background
                    :page-sizes="pageSizes"
                    :page-size="Number(qryArea.pagecount)"
                    :current-page.sync="curPage"
                    :layout="pageLayout"
                    :total="allPage"
                    v-on:current-change="dataReset"
                    v-on:size-change="sizeReset"
                >
                    <el-button type="primary" plain v-on:click="showAll">{{ !isShowAll ? "显示全部" : "分页展示" }}</el-button>
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import conf from "@/config/index";
import datePicker from "@/components/common/datePicker.vue";
export default {
    name: "Statement",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            qryArea: {
                begindate: "", // 默认起始日期
                enddate: "", // 默认结束日期
                pagecount: "20", // 分页条数
                pageoffset: "0", // 起始页
                g_systemtype: "",
                token: ""
            },
            allPage: "0", // 所有数据条数
            dateArr: [],
            pickerOptions: {
                disabledDate: time => {
                    return time.getTime() > new Date().getTime();
                }
            },
            statementInfo: [],
            tableData: [],
            curPage: 1,
            dateSet: { type: "2", min: "1990-01-01", size: "media",val: [] },
            conf: {}, // 初始化配置文件内容
            isShowAll: false,
            pageSizes: [20, 50, 100],
            pageLayout: "total, slot, sizes, prev, pager, next",
            loading:false // 是否正在打印对账单
        };
    },
    mounted () {
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.qryArea.begindate = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 1);
        this.qryArea.enddate = this.nowDate;
        const _x = this.$util.fmtDate(this.qryArea.begindate);
        const _y = this.$util.fmtDate(this.qryArea.enddate);
        this.dateSet.val = [_x,_y];
        //this.$set(this.qryArea, "pagecount", this.$util.getConfig().const.PAGE_SIZE);
        this.getStatement();
    },
    created () {
        this.conf = this.$util.getConfig().const;
    },
    methods: {
        dateInterval (val) {
            this.qryArea.begindate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.qryArea.enddate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        getStatement (val) {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$util.request("acct/checksheet/list", this.qryArea, "GET", true).then(res => {
                if (res.data) {
                    _this.allPage = res.data[3][0].totalcount - 0;
                    _this.statementInfo = res.data;
                }
            });
        },
        showAll(evt) {
            let target = evt.target;
            if (target) {
                if (target.nodeName === "SPAN") {
                    target = evt.target.parentNode;
                }
                target.blur();
            }
            this.isShowAll = !this.isShowAll;
            if (this.isShowAll) {
                this.pageLayout = "total, slot";
                this.curPage = 1;
                this.$set(this.qryArea, "pageoffset", "");
                this.getStatement();
            } else {
                this.pageLayout = "total, slot, sizes, prev, pager, next";
                this.curPage = 1;
                this.$set(this.qryArea, "pageoffset", "0");
                this.getStatement();
            }
        },
        sizeReset (val) {
            this.curPage = 1;
            this.$set(this.qryArea, "pageoffset", "0");
            this.$set(this.qryArea, "pagecount", val + "");
            this.getStatement();
        },
        dataReset (val) {
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            this.$set(this.qryArea, "pageoffset", ((val - 1) * this.qryArea.pagecount).toString());
            this.getStatement();
            /*const _this = this;
            this.$util.request("acct/checksheet/list", this.qryArea, "GET", true).then(res => {
                if (res.data) {
                    _this.allPage = res.data[3][0].totalcount - 0;
                    _this.statementInfo = res.data;
                }
            });*/
        },
        printStatement () {
            const _this = this;
            if(this.$util.isEmpty(this.qryArea.begindate) || this.$util.isEmpty(this.qryArea.enddate)){
                let _m = "请输入完整的日期范围";
                this.$alert(_m,"日期提示");
                return;
            }
            let _x = Object.assign({}, this.qryArea,{"pageoffset": "", "pagecount": ""});
            this.$set(_x, "g_systemtype", conf.systemtype);
            this.$set(_x, "token", _this.$cache.getSessionToken());
            this.loading=true
            this.$util.request("acct/statements/download", _x, "GET", false, true).then(res => {
                this.download(res.data);
            });
            /* const getRootPath = function() {
                return (
                    window.location.protocol + "//" + window.location.host + conf.api.bankUrl
                );
            };
            let openUrl = getRootPath() + "/page/print.html?begindate=" + this.qryArea.begindate + "&enddate=" + this.qryArea.enddate + "&g_systemtype=" + conf.systemtype + "&token=" + this.$cache.getSessionToken();
            window.open(openUrl); */
        },
        // 下载文件
        download (data) {
            if (!data) {
                this.$message({
                    type: "warning",
                    message: "获取文件源失败"
                });
                return false;
            }
            let url = window.URL.createObjectURL(new Blob([data]));
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([data]), "download.pdf");
                return false;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "download.pdf");
            document.body.appendChild(link);
            link.click();
            this.loading=false
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-statement {
    padding-bottom: 50px;
    .date-text{line-height: 40px;margin-right: 10px;}
    .statement-content {
        padding: 0px 20px;
        .statement-form {
            padding: 10px 0px;
            border-bottom: 1px solid #ebebeb;
            >div {
                padding:5px;
            }
        }
        .statement-filter {
            text-align: right;
            padding: 10px 0px;
            .print-btn {
                margin-left: 10px;
            }
        }
        .table-title {
            padding: 10px 0px;
        }
    }
    .is-disabled{
        border-color: #EBEEF5!important;
        color: #C0C4CC!important;
    }
}
</style>
